import React from 'react';
import * as yup from 'yup';
import { FormikInput } from 'Components/frameworks/formik/FormikInput';
import { t } from 'Src/i18n';
import { emailRegex } from 'Utils/regex/RegexHelper';
type VoxpayEmailInputProps = {
  isDisabled?: boolean;
  withValidation?: boolean;
  fieldName: string;
};
export const VoxpayEmailInput = ({
  isDisabled,
  fieldName,
  withValidation = true,
}: VoxpayEmailInputProps) => {
  const validateEmail = yup
    .string()
    .matches(emailRegex, t('booking.partners.linkPayment.email.invalidEmail'))
    .required();
  return (
    <FormikInput
      isDisabled={isDisabled}
      name={fieldName}
      label={t('common.form.labels.email')}
      type="email"
      validate={withValidation ? validateEmail : undefined}
    />
  );
};
